export const categoryLabels = [
    { value: 'hands on', label: 'Hands on' },
    { value: 'art party', label: 'Party' },
    { value: 'demonstration', label: 'Demonstration' },
    { value: 'exhibition', label: 'Exhibition' },
    { value: 'artist talk', label: 'Artist talk' },
    { value: 'panel', label: 'Panel' },
    { value: 'virtual', label: 'Virtual' },
    { value: 'in person', label: 'In person' },
    { value: 'tour', label: 'Tour' },
    { value: 'open studio', label: 'Open studio' },
    { value: 'performance', label: 'Performance' },
    { value: 'fundraiser', label: 'Fundraiser' },
    { value: 'lecture', label: 'Lecture' }
];

export const mediaLabels = [
    { value: 'glass', label: 'Glass' },
    { value: 'painting', label: 'Painting' },
    { value: 'sculpture', label: 'Sculpture' },
    { value: 'installation', label: 'Installation' },
    { value: 'digital', label: 'Digital' },
    { value: 'film', label: 'Film' },
    { value: 'fashion', label: 'Fashion' },
    { value: 'performance', label: 'Performance' },
    { value: 'poetry', label: 'Poetry' },
    { value: 'multi-media', label: 'Multi-media' },
    { value: 'photography', label: 'Photography' }
];

export const convertToUTC = (timeString, timezoneOffset) => {
    // Parse the time string
    const [hours, minutes] = timeString.split(':').map(Number);
  
    // Create a Date object for today
    const today = new Date();
    const date = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      hours,
      minutes
    );
  
    // Convert to UTC
    const utcDate = new Date(date.getTime() - timezoneOffset * 60 * 1000);
  
    // Format the UTC time
    const utcHours = utcDate.getUTCHours().toString().padStart(2, '0');
    const utcMinutes = utcDate.getUTCMinutes().toString().padStart(2, '0');
  
    return `${utcHours}:${utcMinutes}:00 +0000`;
  }

  export const convertTime12to24 = (time12h) => {
    const [time, modifier] = time12h.split(' ');
  
    let [hours, minutes] = time.split(':');
  
    if (hours === '12') {
      hours = '00';
    }
  
    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }
  
    return `${hours}:${minutes}`;
  }

  export const mapEventToImage = {
    "a7e7b0f8-ad32-11ef-bc9a-17f551df6987": "blowingSands.jpg",
    "fdee7cde-ad32-11ef-bc9a-730a9bc762ac": "kaitRhoads.jpg", 
    "b270dc20-adc3-11ef-8733-1b29d9d57e77": "demons.jpg", 
    "a96f1f94-b195-11ef-ba1f-5bbe30387fc1": "flora.png", 
    "0f97b7a6-b72f-11ef-ab91-9309639f2b10": "eva.jpg", 
    "d71a2e5e-b72e-11ef-ab91-67d3ed81805d": "cocoa.jpg", 
    "d39eb6f6-b72d-11ef-ab91-77bab6d9e812": "boundaries.jpeg",
    "1a99521c-b730-11ef-ab91-93629b1f8075": "openMic.png", 
    "d3dc2764-b761-11ef-8725-37ce2b99d73e": "kela.jpg", 
    "a21c5c9e-b770-11ef-b8f3-5f5eb9761fc0": "emerging.jpg", 
    "dea919a4-b770-11ef-b8f3-1fa33effcc07": "joyce.jpg", 
    "193f69e6-b772-11ef-a631-030987190055": "cAM.png", 
    "213a6082-b773-11ef-8208-870c3f9d5d5b": "timber.png", 
    "e6a43d24-b7dd-11ef-b813-1f68c5428726": "huichol.jpg", 
    "749efa3e-b7dd-11ef-b813-e704b2b16f94": "artsAndCulture.png"
  }

export function importAll(r) {
    let images = {};
    r.keys().forEach((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
}
  


